export enum ImageCategoryRoutes {
  base = 'image-category',
  list = 'image-category-list'
}
